// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#chat-list-wrapper {
    height: unset !important;
    aspect-ratio: 1.52;
}
.chat-wrapper .chat-item.info:first-child,
.chat-card .card-body .chat-list .chat-item.info:first-child {
    margin-top: 0;
}
.chat-wrapper .write-your-message .buttons-list,
.chat-card .card-body .write-your-message .buttons-list {
    top: auto !important;
    position: relative !important;
    transform: none !important;
}
.chat-wrapper.chat-item .message .dropdown,
.chat-card .card-body .chat-list .chat-item .message .dropdown {
    top: unset !important;
    right: unset !important;
    position: relative !important;
    transform: unset !important;
}
.chat-wrapper .chat-item .message .dropdown .card-dot-btn.dropdown-toggle,
.chat-card .card-body .chat-list .chat-item .message .dropdown .card-dot-btn.dropdown-toggle {
    margin-right: unset !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
